<div
  [ngClass]="{
    'm-0 h-fit p-6': isAccountSettingsPage,
    'app__profile--view--mode': data?.viewModeOnly
  }"
  class="edit__profile--dialog p-10 max-[480px]:pt-10 max-[480px]:px-5 max-[480px]:pb-0"
  [class]="
    screenWidth > 480
      ? (data?.editType && data?.editType != 'basicInfo') || isAccountSettingsPage
        ? data?.viewModeOnly
          ? 'h-[540px]'
          : 'h-[646px]'
        : ' h-[601px]'
      : 'h-full'
  "
>
  @if (user$ | async; as user) { @if(isAccountSettingsPage){
  <h2 [ngClass]="{ 'edit__profile--subtitle m-0': isAccountSettingsPage }">Profile Picture</h2>
  <div class="user__profile--info--wrapper h-full m-0 relative w-full my-5">
    <input
      type="file"
      class="hidden w-full h-full"
      #fileUpload
      (change)="fileChangeEvent($event)"
      id="fileUpload"
      name="fileUpload"
      accept="image/png,  image/jpeg"
    />
    <div class="h-full items-center justify-end w-fit">
      @if(pendingImgSrc || user?.profile_image_url){
      <div class="relative flex w-fit items-center justify-center user__profile--image">
        <img
          class="user__profile--image w-20 h-20"
          [src]="pendingImgSrc ? pendingImgSrc : user?.profile_image_url ? user?.profile_image_url : '/assets/images/admin-light-grey.png'"
          name="{{ user?.first_middle_name + ' ' + user?.last_name | titlecase }}"
        />
        <span (click)="fileUpload.click()" class="bg-white rounded-full w-8 h-8 flex items-center justify-center absolute">
          <span class="material-icons relative text-lg menuitem-icon material-symbols-outlined text-[#5475C0]">photo_camera </span>
        </span>
      </div>
      }@else {
      <div class="user__profile--image w-20 h-20 rounded-full bg-[#EBF0FA] border-[2px] border-[#EBF0FA] flex items-center justify-center">
        <div class="user__profile--image--wrapper">
          <span (click)="fileUpload.click()" class="bg-white rounded-full w-8 h-8 flex items-center justify-center">
            <span class="material-icons relative text-lg menuitem-icon material-symbols-outlined text-[#5475C0]">photo_camera </span>
          </span>
          <!-- <ngx-avatars
            size="112"
            [src]=""
            name="{{ user?.first_middle_name + ' ' + user?.last_name | titlecase }}"
            [round]="true"
            initialsSize="2"
          ></ngx-avatars> -->
        </div>
      </div>
      }
    </div>
  </div>
  }

  <div class="edit__profile--header">
    <h2 [ngClass]="{ 'edit__profile--title': !!data?.editType, 'edit__profile--subtitle': isAccountSettingsPage }">
      {{
        (data?.editType && data?.editType == 'basicInfo') || isAccountSettingsPage
          ? 'My Basic Information'
          : (data?.viewModeOnly ? (data?.userData?.name | truncateStrPipe : 26) : 'My') + ' Contact Information'
      }}
    </h2>
    @if (!!data?.editType) {
    <div class="app__close--icon mt-[-7px] block">
      <button matTooltipPosition="above" data-dismiss="modal" (click)="closeDialog()" class="web-close-btn">
        <span class="material-icons relative">clear</span>
      </button>
    </div>
    }
  </div>
  <div class="edit__profile--form mt-[-55px]">
    <div class="w-full">
      <form #userEditProfileFormDirective="ngForm" [formGroup]="userEditProfileForm" (ngSubmit)="updateUserInfo(user)">
        <div class="edit__profile--form--container pt-[70px]">
          @if (data?.editType && data?.editType == 'basicInfo' ||isAccountSettingsPage) {
          <div class="sm:mt-0 mt-16">
            <div class="basic__Info--wrapper">
              <mat-form-field appearance="fill" class="form-design-ui">
                <mat-label class="automtic-form-desing-lable"><span class="font-normal">Prefix</span> (Optional)</mat-label>
                <mat-select disableOptionCentering panelClass="move-select-popup" matNativeControl formControlName="prefix" [(ngModel)]="user.prefix">
                  @for(prefix of prefixes;track prefix){
                  <mat-option class="hide-check-box" [value]="prefix">{{ prefix }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="fill" class="form-design-ui">
                <mat-label class="automtic-form-desing-lable font-normal">First Name</mat-label>
                <input matInput placeholder="First name" formControlName="first_name" [(ngModel)]="user.first_name" required />
                @if (userEditProfileForm.controls['first_name'].value == '') {
                <mat-error> First name is required </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="basic__Info--wrapper">
              <mat-form-field appearance="fill" class="form-design-ui">
                <mat-label class="automtic-form-desing-lable font-normal">Middle Name</mat-label>
                <input matInput placeholder="Middle name" formControlName="middle_name" [(ngModel)]="user.middle_name" />
              </mat-form-field>
              <mat-form-field appearance="fill" class="form-design-ui">
                <mat-label class="automtic-form-desing-lable font-normal">Last Name</mat-label>
                <input matInput placeholder="Last name" formControlName="last_name" [(ngModel)]="user.last_name" required />
                @if (userEditProfileForm.controls['last_name'].value == '') {
                <mat-error> Last name is required </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="basic__Info--wrapper">
              <mat-form-field appearance="fill" class="form-design-ui">
                <mat-label class="automtic-form-desing-lable"><span class="font-normal">Suffix</span> (Optional)</mat-label>
                <mat-select disableOptionCentering panelClass="move-select-popup" matNativeControl formControlName="suffix" [(ngModel)]="user.suffix">
                  @for(suffix of suffixes;track suffix){
                  <mat-option class="hide-check-box" [value]="suffix">{{ suffix }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="fill" class="form-design-ui">
                <mat-label class="automtic-form-desing-lable"><span class="font-normal">Nickname</span> (Optional)</mat-label>
                <input matInput placeholder="Nickname" formControlName="your_self" [(ngModel)]="user.your_self" />
              </mat-form-field>
            </div>
            @if (user?.user_type != professionalUserType) {
            <div class="basic__Info--wrapper">
              <reusable-date-input
                style="width: 50% !important; display: block"
                [labelClass]="'font-normal'"
                [ngClassStyle]="
                  userEditProfileForm.controls['birthdate'].dirty &&
                  userEditProfileForm.controls['birthdate'].touched &&
                  userEditProfileForm.controls['birthdate'].invalid
                    ? 'automtic-form-desing-lable-error w-[98%]'
                    : 'w-[98%]'
                "
                [classStyle]="'form-design-ui app__medium--height--form w-[98%]'"
                [title]="'Date Of Birth'"
                [hasMaxDate]="true"
                [maxDate]="todayDate"
                [controlName]="'birthdate'"
                [value]="user.birthdate ? moment(user.birthdate).format('MMM DD, YYYY') : ''"
                [hasError]="userEditProfileForm.controls['birthdate'].hasError"
                [error]="'Birthdate cannot be in the future'"
                (dateChangeEmitter)="handleDateChange($event)"
                (changeEmitter)="handleDateChange2($event)"
              >
              </reusable-date-input>

              <mat-form-field appearance="fill" class="form-design-ui app__medium--height--form relative genderValue genderValueOther">
                <span
                  class="material-icons text-base cursor-pointer absolute"
                  [matTooltip]="
                    'We ask for gender to ensure that inverse relationship types are defined appropriately (e.g. the inverse of \'Mother\' is \'Daughter\')'
                  "
                  [ngClass]="{ 'top-[2px] left-[56px] !important': genderHasValue() || !!user?.gender }"
                >
                  info_outline
                </span>
                <mat-label class="automtic-form-desing-lable relative">
                  <span class="w-full relative font-normal"> Gender </span>
                </mat-label>
                <mat-select
                  disableOptionCentering
                  panelClass="move-select-popup"
                  matNativeControl
                  formControlName="gender"
                  [(ngModel)]="user.gender"
                  required
                >
                  <mat-option class="hide-check-box" value="Male">Male</mat-option>
                  <mat-option class="hide-check-box" value="Female">Female</mat-option>
                  <mat-option class="hide-check-box" value="Other"> Other</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            }
            <!-- @if(!isAccountSettingsPage){ -->
            @if (user?.user_type == professionalUserType) {
            <div class="flex items-center gap-[10px]">
              <mat-form-field appearance="fill" class="form-design-ui">
                <mat-label class="automtic-form-desing-lable font-normal">Professional type </mat-label>
                <mat-select
                  [disabled]="makeselectdisable"
                  disableOptionCentering
                  panelClass="move-select-popup"
                  required
                  matNativeControl
                  formControlName="professional_type_id"
                  [(ngModel)]="user.professional_type_id"
                >
                  @for (countries of ProfessionaltypeData; track countries) {
                  <mat-option [value]="countries.id">
                    {{ countries?.name }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field
                appearance="fill"
                class="form-design-ui"
                [ngClass]="
                  userEditProfileForm.controls['birthdate'].dirty &&
                  userEditProfileForm.controls['birthdate'].touched &&
                  userEditProfileForm.controls['birthdate'].invalid
                    ? 'automtic-form-desing-error'
                    : ''
                "
              >
                <mat-label
                  class="automtic-form-desing-lable"
                  [ngClass]="
                    userEditProfileForm.controls['birthdate'].dirty &&
                    userEditProfileForm.controls['birthdate'].touched &&
                    userEditProfileForm.controls['birthdate'].invalid
                      ? 'automtic-form-desing-lable-error'
                      : ''
                  "
                  >Date Of Birth</mat-label
                >
                <input
                  matInput
                  [matDatepicker]="dp3"
                  (click)="dp3.open()"
                  [max]="todayDate"
                  placeholder="Date Of Birth"
                  formControlName="birthdate"
                  [(ngModel)]="user.birthdate"
                  (dateChange)="logDate($event.value)"
                  style="display: none"
                />
                {{ user?.birthdate ? this.moment(user?.birthdate).format('MMM DD, YYYY') : '' }}
                <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                <mat-error>Birthdate cannot be in the future</mat-error>
              </mat-form-field>
            </div>
            }
            <!-- } -->
            <div class="basic__Info--wrapper">
              <mat-form-field appearance="fill" class="form-design-ui basic__Info--email--input">
                <mat-label class="automtic-form-desing-lable font-normal"> Account Email </mat-label>
                <input
                  matInput
                  placeholder="Account Email"
                  [(ngModel)]="user.email"
                  formControlName="user_email"
                  required
                  disabled
                  [class.disabled__form--input]="true"
                />
                <span matSuffix> <img src="../../../../assets/images/check.svg" class="mr-[8px]" /></span>
              </mat-form-field>
            </div>
          </div>
          } @if (data?.editType && data?.editType == 'contactInfo' ||isAccountSettingsPage) {
          <div class="sm:mt-0 mt-16">
            <p class="edit__profile--subtitle">{{ !!data?.editType ? 'Preferred Contact Methods' : 'Contact Information ' }}</p>
            <div class="basic__Info--wrapper">
              <mat-form-field appearance="fill" class="form-design-ui">
                <mat-label class="automtic-form-desing-lable"> Email</mat-label>
                <input matInput type="email" placeholder="Contact Email" formControlName="contact_email" [(ngModel)]="user.contact_email" />
                @if (userEditProfileForm.controls['contact_email'].errors && userEditProfileForm.controls['contact_email'].value !== '') {
                <mat-error> Incorrect email address. </mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="fill" class="form-design-ui">
                <mat-label class="automtic-form-desing-lable">Phone Number</mat-label>
                <input matInput type="text" placeholder="Telephone" [(ngModel)]="user.phone_no" formControlName="phone_no" />
                @if (userEditProfileForm.controls['phone_no'].errors && userEditProfileForm.controls['phone_no'].value !== '') {
                <mat-error> 15 characters is exceeded </mat-error>
                }
              </mat-form-field>
            </div>
            <p class="edit__profile--subtitle mt-3">Mailing Address</p>
            <div class="contact__Info--wrapper">
              <mat-form-field appearance="fill" class="form-design-ui w-[99.2%]">
                <mat-label class="automtic-form-desing-lable"> Street Address </mat-label>
                <input
                  #streetAddressInput
                  matInput
                  type="text"
                  aria-label="Street"
                  placeholder="Street Address"
                  formControlName="street"
                  [(ngModel)]="user.street"
                />
                @if (userEditProfileForm.controls['street'].errors && userEditProfileForm.controls['street'].value !== '') {
                <mat-error> 100 characters is exceeded </mat-error>
                } @if(user.street && !data?.viewModeOnly) {
                <span matSuffix (click)="user.street = '' && autocomplete == null">
                  <mat-icon class="close-input-icon text-[#898F9E] hover:cursor-pointer mr-5">close</mat-icon>
                </span>
                }
              </mat-form-field>
            </div>
            <div class="contact__Info--wrapper">
              <mat-form-field appearance="fill" class="form-design-ui mobile-full-width-form">
                <mat-label class="automtic-form-desing-lable">State</mat-label>
                <input type="text" placeholder="State" matInput formControlName="state" [(ngModel)]="user.state" [matAutocomplete]="auto2" />
                @if (userEditProfileForm.controls['state'].errors && userEditProfileForm.controls['state'].value !== '') {
                <mat-error> 100 characters is exceeded </mat-error>
                }
                <mat-autocomplete #auto2="matAutocomplete">
                  @if (!stateData.length && isStateDataLoading) {
                  <mat-option disabled>Loading states...</mat-option>
                  } @if (!stateData.length && !isStateDataLoading && userEditProfileForm.controls['country'].value) {
                  <mat-option disabled> No state </mat-option>
                  } @if (!stateData.length && !isStateDataLoading && !userEditProfileForm.controls['country'].value) {
                  <mat-option disabled> Please select country </mat-option>
                  } @if (stateData.length) {
                  <div>
                    @for (state of stateData | filterWorkspace : userEditProfileForm.get('state').value; track state) {
                    <mat-option [value]="state.name" (onSelectionChange)="selectEvent($event, state?.countryCode, state?.isoCode)">
                      {{ state.name }}
                    </mat-option>
                    }
                  </div>
                  }
                </mat-autocomplete>
                @if (user?.state && !data?.viewModeOnly) {
                <div matSuffix (click)="user.state = ''">
                  <mat-icon class="close-input-icon text-[#898F9E] hover:cursor-pointer mr-5">close</mat-icon>
                </div>
                }
              </mat-form-field>
              <mat-form-field appearance="fill" class="form-design-ui mobile-full-width-form">
                <mat-label class="automtic-form-desing-lable">City</mat-label>
                <input type="text" placeholder="City" matInput formControlName="city" [(ngModel)]="user.city" [matAutocomplete]="auto3" />
                @if (userEditProfileForm.controls['city'].errors && userEditProfileForm.controls['city'].value !== '') {
                <mat-error> 100 characters is exceeded </mat-error>
                }
                <mat-autocomplete #auto3="matAutocomplete">
                  @if (!cityData.length && isCityDataLoading) {
                  <mat-option disabled>Loading cities...</mat-option>
                  } @if (!cityData.length && !isCityDataLoading && userEditProfileForm.controls['state'].value) {
                  <mat-option disabled> No city </mat-option>
                  } @if (!cityData.length && !isCityDataLoading && !userEditProfileForm.controls['state'].value) {
                  <mat-option disabled>Please select country and state </mat-option>
                  } @if (cityData.length) {
                  <div>
                    @for (city of cityData | filterWorkspace : userEditProfileForm.get('city').value; track city) {
                    <mat-option [value]="city.name">
                      {{ city.name }}
                    </mat-option>
                    }
                  </div>
                  }
                </mat-autocomplete>
                @if (user?.city && !data?.viewModeOnly) {
                <div matSuffix (click)="user.city = ''">
                  <mat-icon class="close-input-icon text-[#898F9E] hover:cursor-pointer mr-5">close</mat-icon>
                </div>
                }
              </mat-form-field>
            </div>
            <div class="contact__Info--wrapper">
              <mat-form-field appearance="fill" class="form-design-ui mobile-full-width-form">
                <mat-label class="automtic-form-desing-lable">ZIP</mat-label>
                <input type="text" placeholder="ZIP" matInput formControlName="zip" [(ngModel)]="user.zip" />
              </mat-form-field>
              <mat-form-field appearance="fill" class="form-design-ui mobile-full-width-form">
                <mat-label class="automtic-form-desing-lable">Country</mat-label>
                <input type="text" placeholder="Country" matInput formControlName="country" [(ngModel)]="user.country" [matAutocomplete]="auto" />
                @if (userEditProfileForm.controls['country'].errors && userEditProfileForm.controls['country'].value.length > 100) {
                <mat-error> 100 characters is exceeded </mat-error>
                } @if ( userEditProfileForm.controls['country'].value && userEditProfileForm.controls['country'].touched &&
                userEditProfileForm.controls['country'].value.length <= 100 ) {
                <mat-error> Country not found </mat-error>
                }
                <mat-autocomplete #auto="matAutocomplete">
                  @if (!countryData.length) {
                  <mat-option disabled>Loading countries...</mat-option>
                  } @if (countryData.length) {
                  <div>
                    @for (countries of countryData | filterWorkspace : userEditProfileForm.get('country').value; track countries) {
                    <mat-option [value]="countries.name" (onSelectionChange)="selectEvent($event, countries?.isoCode)">
                      {{ countries.name }}
                    </mat-option>
                    }
                  </div>
                  }
                </mat-autocomplete>
                @if (user.country && !data?.viewModeOnly) {
                <div matSuffix (click)="user.country = ''">
                  <mat-icon class="close-input-icon text-[#898F9E] hover:cursor-pointer mr-5">close</mat-icon>
                </div>
                }
              </mat-form-field>
            </div>
          </div>
          } @if(!data?.viewModeOnly){
          <div
            [class]="!isAccountSettingsPage ? 'edit__profile-footer' : ''"
            [ngClass]="{
              'mt-0 sm:mt-[0px] mb-0 ': !!data?.editType && data?.editType == 'basicInfo',
              'mt-[26px] sm:mt-[26px] mb-0 ': data?.editType === 'contactInfo' && !isAccountSettingsPage,
              'm-0': isAccountSettingsPage
            }"
            [style]="screenWidth > 640 && !!data?.editType ? 'box-shadow: -2px -1px 15px rgba(0, 0, 0, 0.1); border-radius: 0px 0px 16px 16px' : ''"
          >
            @if (data?.triggeredFrom == 'continueBtn' && !!data?.editType && data?.editType == 'contactInfo' ) {
            <button class="app__skip-btn mr-2" (click)="$event.stopPropagation(); closeDialog()">Skip</button>
            }
            <button
              type="submit"
              mat-raised-button
              [ngClass]="{
                'w-full': isAccountSettingsPage,
                'app__btn--primary--medium w-[226px] h-[48px]': !!data?.editType
              }"
              [class.disable-button-continue-std]="
                (!!data?.editType && data?.editType == 'basicInfo') || isAccountSettingsPage
                  ? userEditProfileForm.controls['first_name'].valid && userEditProfileForm.controls['last_name'].valid
                  : ''
              "
            >
              {{ data?.triggeredFrom == 'continueBtn' ? 'Save and Continue' : 'Save' }}
            </button>
          </div>
          }
        </div>
      </form>
    </div>
  </div>
  } @else if(data?.userData?.id){
  <div class="w-full">
    <div class="loader-container grid grid-cols-1 p-4">
      @for (item of [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4}]; track item) {
      <div class="w-full" id="{{ item.id }}">
        <div class="ph-item w-full content__loader p-0 border-none">
          <div class="ph-col-12 p-0 m-0">
            <div class="ph-row">
              <div class="ph-col-12 h-[68px]"></div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
  }
</div>
